import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin';

gsap.registerPlugin(ScrollTrigger, MorphSVGPlugin);

export default function scrollHeader() {
  const header = document.querySelector(".site-header");

  if (!header) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: header,
      start: 'top top',
      toggleActions: 'play none none reverse'
    }
  });

  tl
    .to(header, {
      boxShadow: '1px 1px 3px rgba(0,0,0,0.3)',
    }, 0)
    .to('.site-header__logo', {
      scale: 0.8,
    }, 0)
    .to('.site-header__main__container', {
      paddingTop: 0,
      paddingBottom: 0,
    }, 0)
    .to('#site-logo-bottom #large', {
      morphSVG: '#site-logo-bottom #small',
      filter: 'drop-shadow(1px 1px 2px rgba(0,0,0,0.3))',
    }, 0)
}